import { writable } from 'svelte/store'

export const currentStep = writable(0)
export const currentSubStep = writable(0)
export const currentProgress = writable(0)

export const scrollDirection = writable("down")
export const reachedScrollBottom = writable(false)

export const spotlightActive = writable(false)